import { type MutationParams, RequestMaker } from '../../request-maker';

export default class UndoDismissalRequestMaker extends RequestMaker {
	makeRequest({ productId, contextResolver }: MutationParams): Request {
		return new Request(this.endpoint, {
			method: 'POST',
			credentials: 'include',
			mode: 'cors',
			headers: this.getHeaders(),
			body: JSON.stringify({
				query: undoDismissalMutation,
				variables: {
					args: {
						productId,
						context: this.getContext(contextResolver),
					},
				},
			}),
		});
	}
}

const undoDismissalMutation = `
mutation undoDismissal($args: AppRecUndoDismissalInput!) {
  appRecommendations {
    undoDismissal(input: $args) {
      result {
        undone
        description
      }
      success
      errors {
        message
        extensions {
          errorType
          statusCode
        }
      }
    }
  }
}
`;
